import { Link } from "react-router-dom";

export function NotFound(): React.ReactElement {
  return (
    <main className="flex min-h-screen items-center justify-center p-8">
      <div className="text-center">
        <h1 data-testid="not-found-status" className="text-6xl font-bold">
          404
        </h1>
        <p data-testid="not-found-message" className="mt-4 text-lg text-muted-foreground">
          Page not found
        </p>
        <Link
          data-testid="not-found-home-link"
          to="/"
          className="mt-6 inline-block text-primary underline-offset-4 hover:underline"
        >
          Go home
        </Link>
      </div>
    </main>
  );
}
